/* Mega-Menü Sternkerze: Bildvorschau wechselt beim Ueberfahren eines Links.
   Faellt ohne JavaScript sauber auf das Standardbild zurueck. */
(function () {
  'use strict';

  function start(mega) {
    var vorschau = mega.querySelector('.sk-mega__vorschau');
    if (!vorschau) return;

    var bild = vorschau.querySelector('.sk-mega__vorschau-bild');
    var titel = vorschau.querySelector('.sk-mega__vorschau-titel');
    if (!bild || !titel) return;

    var standardBild = vorschau.getAttribute('data-sk-standard-bild');
    var standardTitel = vorschau.getAttribute('data-sk-standard-titel');
    var standardZiel = vorschau.getAttribute('href');
    var timer = null;

    // Bilder vorab laden, damit der Wechsel nicht flackert
    var vorgeladen = {};
    function vorladen(url) {
      if (!url || vorgeladen[url]) return;
      vorgeladen[url] = true;
      var i = new Image();
      i.src = url;
    }

    function setzen(url, text, ziel) {
      if (!url || bild.getAttribute('src') === url) return;
      clearTimeout(timer);
      bild.classList.add('is-wechselnd');
      timer = setTimeout(function () {
        bild.setAttribute('src', url);
        titel.textContent = text || '';
        vorschau.setAttribute('href', ziel || standardZiel);
        bild.classList.remove('is-wechselnd');
      }, 120);
    }

    var links = mega.querySelectorAll('.sk-mega__link[data-sk-bild]');
    Array.prototype.forEach.call(links, function (a) {
      var url = a.getAttribute('data-sk-bild');
      a.addEventListener('mouseenter', function () {
        vorladen(url);
        setzen(url, a.getAttribute('data-sk-titel'), a.getAttribute('href'));
      });
      a.addEventListener('focus', function () {
        vorladen(url);
        setzen(url, a.getAttribute('data-sk-titel'), a.getAttribute('href'));
      });
    });

    // Verlaesst man das Menü, wieder das Standardbild zeigen
    mega.addEventListener('mouseleave', function () {
      setzen(standardBild, standardTitel, standardZiel);
    });

    // Beim ersten Ueberfahren die Bilder der sichtbaren Spalte vorladen
    mega.addEventListener('mouseenter', function laden() {
      Array.prototype.forEach.call(links, function (a) {
        vorladen(a.getAttribute('data-sk-bild'));
      });
      mega.removeEventListener('mouseenter', laden);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sk-mega'), start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
